import { Component, OnInit } from '@angular/core';
import { CommonFunctionService, UserMerchantData } from './../../../services/Common/common-function.service';
import { SettingsService } from '../../../services/settings/settings.service';
const swal = require('sweetalert');
import { Router, ActivatedRoute } from "@angular/router";
import { PayoutService } from 'src/app/services/payout.service';
import { environment } from '../../../../environments/environment';
const _clone = (d) => JSON.parse(JSON.stringify(d));
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
@Component({
  selector: 'app-pay-out-accountdetails',
  templateUrl: './pay-out-accountdetails.component.html',
  styleUrls: ['./pay-out-accountdetails.component.scss']
})
export class PayOutAccountdetailsComponent implements OnInit {
  invalidfile: boolean = false;
  PayoutAccountkeyid = null;
  Securitybtn: boolean = false;
  isimgHidden: boolean;
  EdicustomerAccId: boolean = false;
  nonEdicustomerAccId: boolean = true;
  private newAttribute: any = {};
  PayoutCustomerAccountId: any;
  Fromdate1: any;
  todate1: any;
  ContactList = [];
  loggedinuseremail: any;
  MerchantKeyId: any;
  PayoutAccountid = new FormControl('', []);
  Bankdetailserrormessage: boolean = false;
  EditBankdetailserrormessage: boolean = false;
  viewid: any;
  BankIfsccode: any;
  BankAccnum: any;
  ConfirmBankAccnum: any;
  EditSecurity: boolean = false;
  AddSecurity: boolean = true;
  policycheckbox: any
  ispolicy: boolean = false;
  uaturl: boolean = false;
  produrl: boolean = false;
  imagecheck: any;
  contenttype: any;
  imagefile: any;
  fileSize: any;
  maxFileSize = 4000;
  isFileHavingProperSize: boolean = false;
  maxWidth = 200;
  maxHeight = 200;
  content: any;
  ContentType: any;
  img: any
  imageUrl: string = "/assets/img/default-image.png";
  fileToUpload: File = null;

  myFiles: string[] = [];
  DateTime;
  isUploadFile: boolean = false;
  isfileValid: boolean = true;
  validFileExtensions;

  ipAddress = localStorage.getItem('ipaddress');;
  itemimage: any;
  isConfirmNumberSameAsAccountnumber: boolean = true;
  bAccountNumber = new FormControl('', [
    Validators.required,
    Validators.pattern('^(?! )(?!0000000)^[a-zA-Z0-9]{9,18}$')
  ]);
  bConfirmAccountNumber = new FormControl('', [
    Validators.required,
    Validators.pattern('^(?! )(?!0000000)[a-zA-Z0-9]{9,18}$')
  ]);
  bBankCode = new FormControl('', [Validators.required, Validators.pattern('^(?!0 )[A-Z]{4}0(?!000000)[A-Z0-9]{6}$')]);
  ifsccodedetails: boolean = false;
  IfscBranchName: any;
  IfscBankName: any;
  Accountid: any;
  // PayoutAccountkeyid:any;
  requiredAccountiderror: boolean = false;
  constructor(private route: ActivatedRoute, private commonfunction: CommonFunctionService, private service: PayoutService, private router: Router) {
    this.GetPayOutconatctdetails();
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
      this.Accountid = params['PayOutId'];
      if (this.Accountid != null && this.Accountid != "") {
        this.PayoutAccountkeyid = this.Accountid;
        this.requiredAccountiderror = true;
      }
      if (this.viewid > 0) {
        this.EditSecurity = true;
        this.AddSecurity = false;
        let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
        this.service.viewPayOutAccountdetails(merchantdata.MerchantKeyId, this.viewid).subscribe(result => {
          if (result != null) {
            this.BankAccnum = result.AccountNumber;
            this.ConfirmBankAccnum = result.AccountNumber
            this.BankIfsccode = result.IFSCCode;
            this.PayoutCustomerAccountId = result.CustomerAccountId;
            if (this.PayoutCustomerAccountId != null && this.PayoutCustomerAccountId != "") {
              this.EdicustomerAccId = false;
              this.nonEdicustomerAccId = true;
            }
            else {
              this.EdicustomerAccId = true;
              this.nonEdicustomerAccId = false;
            }
          }
        });
      }
      else {
        this.EditSecurity = false;
        this.AddSecurity = true;
      }
    }); 
  }

  ngOnInit() {
    if (environment.production) {
      this.produrl = true;
      this.uaturl = false;
    }
    else {
      this.uaturl = true;
      this.produrl = false;


    }
  }
  GetIfsccodedetails() {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.GetIfsccodedetails(this.bBankCode.value, merchantdata.MerchantKeyId).subscribe(result => {
      if (result != null) {
        this.ifsccodedetails = false;
        this.IfscBankName = result.BankName;
        this.IfscBranchName = result.BranchName;
      }
      else {
        this.ifsccodedetails = true;
        this.IfscBankName = "";
        this.IfscBranchName = "";

      }


    });
  }









  SaveBankAccountDetails() {
    this.Securitybtn = true;
    let form = {
      Id: 0,
      MerchantKeyId: 0,
      IFSCCode: "",
      AccountNumber: "",
      UpiVPA: "",
      status: "",
      UserName: "",
      UpdatedDateTime: "",
      ApprovalDocument: "",
      CustomerAccountId: "",
      PayoutAccountNumber: "",
      PayoutProcessor: "",
      UserIp: "",
      PaymentType: "",
      LoginUserId: ''
    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.UserName = this.commonfunction.getUserName();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    form.IFSCCode = this.bBankCode.value;
    form.AccountNumber = this.bAccountNumber.value;
    form.UserIp = this.ipAddress;
    form.PaymentType = "Credit";
    form.CustomerAccountId = this.PayoutAccountid.value;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    if (this.PayoutAccountid.value != null && this.PayoutAccountid.value != "") {
      form.CustomerAccountId = form.CustomerAccountId.split('-')[0];
    }

    if (this.viewid > 0) {
      form.Id = this.viewid;
    }
    const frmData = new FormData();
    frmData.append("fileUpload", this.myFiles[0]);
    this.service.InserBankaccountdetails(form).subscribe(res => {
      if (res != null) {
        swal("Added", "Created Successfully", "success");
        this.router.navigate(["PayOut/managePayoutAccountdetails"]);
        // window.location.reload();
        if (this.imagecheck == "Image is Updated") {
          this.service.InsertItem(res.Id, merchantdata.MerchantKeyId, frmData).subscribe(result => {

          })
        }
      }
    });

  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
     if (charCode > 31 && (charCode < 48 || charCode > 57)) {
     return false;
     }
     return true;
      }

  onChange() {
    if (this.bAccountNumber.value == this.bConfirmAccountNumber.value) {
      this.isConfirmNumberSameAsAccountnumber = true;
    }
    else {
      if (this.bAccountNumber.value == "" || this.bConfirmAccountNumber.value == "") {
        this.isConfirmNumberSameAsAccountnumber = true;
      }
      else {
        this.isConfirmNumberSameAsAccountnumber = false;
      }

    }
  }
 
  bAccountNumbererrors() {
    return this.bAccountNumber.hasError('required')
      ? 'Bank Account Number is required'
      : this.bAccountNumber.hasError('pattern')
        ? 'Enter Valid Account Number. It allows only 9 to 18 digits'
        : '';
  }
  bBankCodeerrors() {
    return this.bBankCode.hasError('required')
      ? 'IFSC Code/Bank Code is required'
      : this.bBankCode.hasError('pattern')
        ? 'IFSC Code/Bank Code format should be like eg:AAAA0000001'
        : '';
  }


  bconfirmAccountNumbererrors() {
    return this.bConfirmAccountNumber.hasError('required')
      ? 'Confirm New Bank Account Number is required'
      : this.bConfirmAccountNumber.hasError('pattern')
        ? 'Enter Valid Account Number. It allows only 9 to 18 digits'
        : '';
  }
  getFileDetails(e, value) {

    //  this.validFileExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png"]; 
    this.validFileExtensions = [".jpeg", ".jpg", ".png", ".pdf"];
    for (var i = 0; i < e.target.files.length; i++) {


      var type = e.target.files[i].name.split('.')[1];
      if (type.toUpperCase() != "JPEG" && type.toUpperCase() != "JPG" && type.toUpperCase() != "PNG" && type.toUpperCase() != "PDF") {
        this.invalidfile = true;
      }
      else {
        this.myFiles.push(e.target.files[i], value);
        var sFileName = e.target.files[i].name;
        this.fileSize = e.target.files[i].size;
        this.invalidfile = false;
      }


      if (sFileName.length > 0) {
        this.imagecheck = "Image is Updated"
        var blnValid = false;
        for (var j = 0; j < this.validFileExtensions.length; j++) {
          var sCurExtension = this.validFileExtensions[j];
          if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
            blnValid = true;
            this.isfileValid = true;
            break;
          }
        }

        if (!blnValid) {
          this.isfileValid = false;
          // alert("Sorry, " + sFileName + " is invalid, allowed extensions are: " + this.validFileExtensions.join(", "));
          return false;
        }
      }
    }
    if (this.myFiles.length != null) {
      this.isUploadFile = true;
    }
    else {
      this.isUploadFile = false;
    }
    if (this.fileSize < this.maxFileSize) {
      this.isFileHavingProperSize = false;
    }
    else {
      this.isFileHavingProperSize = true;
    }

  }
  click() {
    this.policycheckbox = !this.policycheckbox;
    if (this.policycheckbox)
      this.ispolicy = true;
    else
      this.ispolicy = false;
  }


  CheckAccNumAndIfsccode() {
    if (this.bAccountNumber.value != "" && this.bBankCode.value != "") {
      let form = {

        Id: 0,
        MerchantKeyId: 0,
        IFSCCode: "",
        AccountNumber: "",
        UpiVPA: "",
        status: "",
        UserName: "",
        UpdatedDateTime: "",
        ApprovalDocument: "",
        CustomerAccountId: "",
        PayoutAccountNumber: "",
        PayoutProcessor: "",
        UserIp: "",
        PaymentType: "",

      };
      let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
      form.MerchantKeyId = merchantdata.MerchantKeyId;
      form.IFSCCode = this.bBankCode.value;
      form.AccountNumber = this.bAccountNumber.value;
      this.service.checkAccountdetails(form).subscribe(result => {

        if (result != null) {
          if (result == true) {
            this.Bankdetailserrormessage = true;
          }
          else {
            this.Bankdetailserrormessage = false;
          }
        }
      });
    }
  }


  GetPayOutconatctdetails() {

    this.GetPayOutcontactfilter((data) => {
      // cache our list
      // var List = _clone(data);;
      // List .forEach(element => {
      //   if (element.CustomerAccountId  !="" &&  element.CustomerAccountId  !=null) {
      //     var CustomerAccountId=element.CustomerAccountId 
      //     var FirstName=element.FirstName 
      //     this.newAttribute = {CustomerAccountId,FirstName};   
      //     this.ContactList.push(this.newAttribute); 
      //   }

      // });


    });
  }

  GetPayOutcontactfilter(cb) {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.loggedinuseremail = this.commonfunction.getUserId();
    this.MerchantKeyId = merchantdata.MerchantKeyId;

    this.Fromdate1 = "2017-01-01";
    this.todate1 = new Date().toISOString().slice(0, 10);
    const req = new XMLHttpRequest();
    this.service.viewPayOutFilterdataurls(this.MerchantKeyId, this.Fromdate1, this.todate1).subscribe(data => {
      if (data != null) {
        var List = _clone(data);;
        List.forEach(element => {
          if (element.CustomerAccountId != "" && element.CustomerAccountId != null) {
            var CustomerAccountId = element.CustomerAccountId
            var FirstName = element.FirstName
            this.newAttribute = { CustomerAccountId, FirstName };
            this.ContactList.push(this.newAttribute);
          }

        });
      }
    });
    // req.open('GET',
    //   environment.viewPayOutFilterdataurl + "?MerchantKeyId=" + this.MerchantKeyId + "&fromdate=" + this.Fromdate1 + "&todate=" + this.todate1 + "&CompayName=" + ""
    //   + "&CustomerId=" + "" +"&CustomerName=" + ""  + "&MobileNumber=" + "");
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };

    // req.send();    
  }
}
